import React, { useEffect, useState } from "react";
import './FooterDesc.css'

const FooterDesc = () => {
    const [width, setWidth] = useState({
        winWidth: window.innerWidth
    });

    const detectSize = () => {
        setWidth({
            winWidth: window.innerWidth
        })
    }

    useEffect(() => {
        window.addEventListener('resize', detectSize)

        return (() => {
            window.removeEventListener('resize', detectSize)
        })
    }, [width])

    return (
        <>
            <section className="page-section" id="contact1" style={{ userSelect: "none" }}>
                <div className="container">
                    <div className="row align-items-">
                        <div className="col-md-6 textEffect text-white d-flex flex-column gap-3">
                            <span className="fs-4 fw-bold text-center text-md-start">
                                Welcome to MV Nails House Salon!
                            </span>
                            <span className="text-white" >
                                Step into a world of beauty, relaxation, and elegance at MV Nails House
                                Salon. We are dedicated to providing top-quality nail care, spa
                                treatments, and personalized services that leave you feeling refreshed
                                and confident.
                            </span>
                            <span className="text-white mb-3">
                                Whether you're here for a classic manicure, a luxurious pedicure, or
                                stunning nail art, our expert team is committed to delivering the
                                perfect experience.
                            </span>
                        </div>
                        <div className="col-md-6 text-white mt-4 mt-md-0 d-flex flex-column align-items-center text-center textEffect">
                            <span className="fs-4 fw-bold mb-3 text-center text-md-start">Services</span>
                            <ul className="list-unstyled">
                                <li className="mb-2">• Nail Art</li>
                                <li className="mb-2">• Gel polish</li>
                                <li className="mb-2">• Nail Cutting and Filling</li>
                                <li className="mb-2">• Nail Extensions</li>
                                <li className="mb-2">• Polish Removal</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FooterDesc;